// extracted by mini-css-extract-plugin
export default {"checkbox-group":"checkbox-group_checkbox-group__j9gzX","label":"checkbox-group_label__nDUNw"};